import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const GetComparisonTableRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const MetricValueSchema = z.object({
  owned: z.number().nullable(),
  compSet: z.number().nullable(),
  deltaVsMarket: z.number().nullable(),
});

export const GetComparisonTableResponseDtoSchema = z.object({
  periods: z.array(
    z.object({
      period: z.string(),
      dateRange: z.string(),
      occupancy: MetricValueSchema,
      residentTurnover: MetricValueSchema,
      averageMonthlyRent: MetricValueSchema,
      marginPercent: MetricValueSchema,
      totalAdmissions: MetricValueSchema,
      totalDischarges: MetricValueSchema,
      staffingRatio: MetricValueSchema,
      averageTenure: MetricValueSchema,
      turnoverRate: MetricValueSchema,
      alertsPerPerson: MetricValueSchema,
      flagsPerPerson: MetricValueSchema,
      avgDaysToResolve: MetricValueSchema,
      alertsResolutionEffectiveness: MetricValueSchema,
    })
  ),
});

export type GetComparisonTableRequestDto = z.infer<
  typeof GetComparisonTableRequestDtoSchema
>;

export type GetComparisonTableResponseDto = z.infer<
  typeof GetComparisonTableResponseDtoSchema
>;

export const getComparisonTable = (
  params: GetComparisonTableRequestDto,
  config?: AxiosRequestConfig<GetComparisonTableRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`market-intelligence/facilities/${facilityId}/comparison-table`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetComparisonTableResponseDtoSchema));
};
